export default __webpack_public_path__ + "static/media/dashboard_psychology_session_icon.c02e4a17.svg";